export default {
  // company summary
  'reliability_management.company_summary_container.title': 'Company Summary',
  'reliability_management.company_summary_container.title_filtered':
    'Company Summary, Filtered*',
  'reliability_management.company_summary_container.print.filtered_label':
    '*Filters',

  'reliability_management.company_summary_container.reliability_trend.error':
    'There was a problem loading the Company Reliability trend',
  'reliability_management.company_summary_container.reliability_trend.retry_error':
    'Company Reliability trend data could not be loaded',
  'reliability_management.company_summary_container.company_trends.error':
    'There was a problem loading the Company trends',
  'reliability_management.company_summary_container.company_trends.retry_error':
    'Company trends could not be loaded',
  'reliability_management.company_summary_container.reliability_trend.title':
    'Average Company Reliability Score',
  'reliability_management.company_summary_container.reliability_trend.filtered.title':
    'Average Reliability Score, Filtered',

  'reliability_management.company_summary_container.detected_risk_trend.error':
    'There was a problem loading the Company Detected Risk trend',
  'reliability_management.company_summary_container.detected_risk_trend.retry_error':
    'Company Detected Risk trend could not be loaded',
  'reliability_management.company_summary_container.detected_risk_trend.title':
    'Company Risks Over Time',
  'reliability_management.company_summary_container.detected_risk_trend.filtered.title':
    'Risks Over Time, Filtered',

  'reliability_management.company_summary.spof_label': 'SPoF',
  'reliability_management.company_summary.company_summary_team_group_list_card.tooltip':
    'No risks were detected at the time of evaluation, please check the individual services on the team for details',
  'reliability_management.company_summary.company_summary.company_team_group_list_card.avg_score':
    'Avg. Score',
  'reliability_management.company_summary.company_summary.company_summary_service_list_card.tooltip1':
    'Single Point of Failure',
  'reliability_management.company_summary.company_summary.company_summary_service_list_card.tooltip2':
    'dependencies may be critical, meaning a failure of that dependency may result in an outage. This is a setting that is configurable per dependency per service.',

  'reliability_management.company_summary_container.list_controls.tag_filter.label':
    'Filter By',
  'reliability_management.company_summary_container.list_controls.tag_filter.placeholder':
    'Service Tags',

  'reliability_management.company_summary_container.services_all.header':
    'All Services',
  'reliability_management.company_summary_container.services_filtered.header':
    'Matching Services',

  // report table
  'reliability_management.report_table_reliability.empty':
    'No scores can be found for this team.',
  'reliability_management.report_table_risk.empty':
    'No risks can be found for this team',

  // team risk report
  'reliability_management.team_risk_report.header': 'Team Risk Report',
  'reliability_management.team_risk_report.header_export': 'Export',
  'reliability_management.team_risk_report.error':
    "There was a problem loading this team's team risk report. Please try again.",
  'reliability_management.team_risk_report.select_team_label': 'Team',
  'reliability_management.team_risk_report.not_applicable_tooltip': 'n/a',
  'reliability_management.team_risk_report.trend_chart_title':
    'Total Risks Over Time',
  'reliability_management.team_risk_report.service_risk_card_title':
    'Current Risks',
  'reliability_management.team_risk_report.trend_error':
    "There was a problem loading this team's team risk trend. Please try again.",

  // team reliability report
  'reliability_management.team_reliability_report.header': 'Team Score Report',
  'reliability_management.team_reliability_report.header_export': 'Export',
  'reliability_management.team_reliability_report.error':
    "There was a problem loading this team's team score report. Please try again.",
  'reliability_management.team_reliability_report.select_team_label': 'Team',
  'reliability_management.team_reliability_report.not_applicable_tooltip':
    'n/a',
  'reliability_management.team_reliability_report.dependency_not_passed_tooltip':
    '1 or more dependencies in this service has a non-passing state',
  'reliability_management.team_reliability_report.policy_evaluation_run_details_never_tested':
    'Never tested',
  'reliability_management.team_reliability_report.score_card_title':
    'Average Reliability Score',
  'reliability_management.team_reliability_report_trend.error':
    "There was a problem loading this team's team score report trend. Please try again.",
  'reliability_management.team_reliability_report.trend_chart_title':
    'Average Reliability Score Over Time'
}
